import React, { useRef } from "react";

export default function Uploader({selected, selectHandler, decorationType, removeHandler, texts}) {
  const inputRef = useRef();
  const changeHandler = (evt) => {
    selectHandler(
      decorationType,
      URL.createObjectURL(evt.target.files[0])
    );
  };
  return (
    <div className={`upload-img-body ${selected ? "active" : ""}`}>
      <input
        type="file"
        ref={inputRef}
        style={{ display: "none" }}
        accept=".gif,.jpg,.jpeg,.png"
        onChange={changeHandler}
      />
      <button className="upload-btn-m" onClick={() => inputRef.current.click()}>
        <span>{texts["selectImage"]}</span>
      </button>
      <img
        src={selected ? selected.image : ""}
        alt="User uploaded rug"
        width="100%"
      />
      <span className="close-icon" onClick={() => removeHandler(decorationType)} />
    </div>
  );
}
